import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { OnwardTooltip } from '@/styles/blocks';

// Kebab (3-dot) menu for a grid row. `actions` = [{ label, onClick, color, disabled, disabledReason }].
const RowMenu = ({ actions = [], size = 'small' }) => {
    const [anchor, setAnchor] = useState(null);
    const close = () => setAnchor(null);

    if (!actions.length) return null;

    return (
        <>
            <IconButton
                size={size}
                onClick={(e) => {
                    e.stopPropagation();
                    setAnchor(e.currentTarget);
                }}
            >
                <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu
                anchorEl={anchor}
                open={!!anchor}
                onClose={close}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                {actions.map((action) => {
                    const item = (
                        <MenuItem
                            key={action.label}
                            disabled={action.disabled}
                            onClick={(e) => {
                                e.stopPropagation();
                                close();
                                action.onClick();
                            }}
                            style={action.color && !action.disabled ? { color: action.color } : undefined}
                        >
                            {action.label}
                        </MenuItem>
                    );

                    if (!action.disabled || !action.disabledReason) return item;

                    // A disabled item fires no mouse events, so the tooltip hangs off a wrapper.
                    return (
                        <OnwardTooltip key={action.label} title={action.disabledReason} placement="left">
                            <span>{item}</span>
                        </OnwardTooltip>
                    );
                })}
            </Menu>
        </>
    );
};

export default RowMenu;
